import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CustomActions extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CustomActions'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: '',
      description: '',
      userId: null,
      guestId: null,
    }
  }
}
const servicePath = 'custom-actions'
const servicePlugin = makeServicePlugin({
  Model: CustomActions,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
